<template>
  <div id="user-edit-tab-info">
    <div id="teacherProfileUpdateLoadingDiv" class="vs-con-loading__container">
      <!-- Avatar Row -->
      <form>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-start flex-col sm:flex-row">
              <img width="200" :src="data_local.image" class="mr-8 rounded" />
              <div>
                <p class="text-lg font-medium mt-8 sm:mt-8">{{ data.name  }} {{ data.last_name  }}</p>
                <p class="text-md">{{ data.lastSeenAgo  }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="First Name" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" />
            <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Last Name" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="name" />
            <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" label="Email" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" />
            <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="">
              <template slot="prepend">
                <div class="mt-10 prepend-text bg-primary">
                  <span>+45</span>
                </div>
              </template>

              <vs-input class="w-full mt-4" label="Phone" v-model="data_local.phone" type="phone" v-validate="'required|numeric|digits:8'" name="phone" />
            </vx-input-group>
              <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
          </div>
        </div>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vue-dawa class="w-full m-0" @select="selectAddressItem($event, 'profileAddressObject')"
              :val="data_local.one_line_address"
              :showMax="5"
              placeholder=""
              containerId="settingAddressContainer"
              fieldClasses="vs-inputx vs-input--input normal w-full"
              fieldId="your-field-id"
              ref="your-field-id"
              fieldName="your-field-name">
              <label slot="label-top" for="field-2">Address</label>
            </vue-dawa>
          </div>
        </div>

        <vs-divider/>

        <div class="vx-row mt-base mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <label>Phone number</label>
            <vs-switch v-model="verify">
                <span slot="on">Verified</span>
                <span slot="off">Not Verified</span>
            </vs-switch>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <label>Email</label>
            <vs-switch v-model="email_verify">
                <span slot="on">Verified</span>
                <span slot="off">Not Verified</span>
            </vs-switch>
          </div>
        </div>

        <vs-divider/>

        <div class="vx-row mb-base">
          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Password" v-validate="'min:6'" name="password" v-model="data_local.password"  />
            <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>

          <div class="vx-col md:w-1/2 w-full">
            <vs-input class="w-full mt-4" type="password" label="Confirm Password" v-validate="'min:6'" name="password" v-model="data_local.password"  />
            <span class="text-danger text-sm"  v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
        </div>

        <vs-divider/>

        <div class="vx-row">
          <div class="vx-col md:w-1/6 w-full mt-base mb-base">
            <vs-switch @input="updateUserStatus" style="width: 70px;" color="success" v-model="status">
                <span slot="on">Active</span>
                <span slot="off"> Blocked</span>
            </vs-switch>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto mt-2" color="danger" @click="openDeleteTeacherConfirm">Delete Teacher</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
              <vs-button class="ml-4 mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import VueDawa from '@ancaio/vue-dawa/sfc'

export default {
  components: {
    vSelect,
    VueDawa
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      statusOptions: [
        { label: "Active",  value: "active" },
        { label: "Blocked",  value: "blocked" },
        { label: "Deactivated",  value: "deactivated" },
      ],
      roleOptions: [
        { label: "Admin",  value: "admin" },
        { label: "User",  value: "user" },
        { label: "Staff",  value: "staff" },
      ],
      verify: (this.data.verify == "1") ? true : false,
      email_verify: (this.data.email_verify == "1") ? true : false,
      status: (this.data.status == "active") ? true : false,
      oneLineAddress : this.data.one_line_address,
    }
  },
  computed: {
    status_local: {
      get() {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set(obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set(obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    selectAddressItem (payload, objectName) {
      this.oneLineAddress = payload.oneLineAddress
    },
    capitalize(str) {
      return str.slice(0,1).toUpperCase() + str.slice(1,str.length)
    },
    save_changes() {
      this.$validator.validateAll().then(result => {
        if (result) this.update_user()
      })
    },
    openDeleteTeacherConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure to comfirm to delete this teacher ?',
        accept: this.acceptAlert
      })
    },
    acceptAlert() {
      this.$vs.loading({ color: '#ff8000' })

      this.$store.dispatch("userManagement/deleteTeacher", this.data_local.id)
        .then(res => { 
          this.$vs.loading.close()

          this.$router.push("/teachers").catch(() => {})

          this.$vs.notify({
            title: "Success.",
            text: "Teacher deleted successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    update_user() {
      var self = this
      
      this.$vs.loading({
        container: '#teacherProfileUpdateLoadingDiv',
        scale: 0.6
      })

      let data = {
        name : this.data_local.name,
        last_name : this.data_local.last_name,
        email : this.data_local.email,
        phone : this.data_local.phone,
        teacher_id : this.data_local.id,
        verify : (this.verify) ? '1' : '0',
        email_verify : (this.email_verify) ? '1' : '0',
        one_line_address : this.oneLineAddress,
      }

      if(this.data_local.password != true && this.data_local.password != "") data.password = this.data_local.password

      this.$store.dispatch("userManagement/updateTeacher", data)
        .then(res => { 
          this.$vs.loading.close('#teacherProfileUpdateLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Teacher updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#teacherProfileUpdateLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    updateUserStatus() {
      var self = this
      this.$vs.loading({
        container: '#teacherProfileUpdateLoadingDiv',
        scale: 0.6
      })

      let data = { 
        teacher_id : this.data_local.id,
        status : (this.status) ? 'active' : 'blocked',
      }

      this.$store.dispatch("userManagement/updateTeacherStatus", data)
        .then(res => { 
          this.$vs.loading.close('#teacherProfileUpdateLoadingDiv > .con-vs-loading')

          this.$vs.notify({
            title: "Success.",
            text: "Teacher updated successfully.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        })
        .catch(err => { 
          this.$vs.loading.close('#teacherProfileUpdateLoadingDiv > .con-vs-loading')

          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }
        })
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    },
  },
}
</script>
